/* eslint-disable import/no-anonymous-default-export */
import { lazy } from "react";

import AddIcon from "@mui/icons-material/Add";
import ListAltIcon from "@mui/icons-material/ListAlt";
import FlagOutlinedIcon from "@mui/icons-material/FlagOutlined";
import HomeWorkOutlinedIcon from "@mui/icons-material/HomeWorkOutlined";
import RouteOutlinedIcon from "@mui/icons-material/RouteOutlined";
const hiringNavItems = [
  {
    name: "ثبت دربستی",
    path: "/hiring",
    icon: AddIcon,
  },
  {
    name: "لیست دربستی‌ها",
    path: "/hiring-list",
    icon: ListAltIcon,
  },
  {
    name: "ثبت تقاضای دربستی",
    path: "/hiring-request",
    icon: AddIcon,
  },
  {
    name: "لیست تقاضای دربستی",
    path: "/hiring-request-list",
    icon: ListAltIcon,
  },
  {
    name: "دربستی برنامه‌ریزی شده",
    path: "/scheduled-hiring",
    icon: AddIcon,
  },
  {
    name: "لیست دربستی برنامه‌ریزی شده",
    path: "/scheduled-hiring-list",
    icon: ListAltIcon,
  },
  {
    name: "دربستی‌های آزاد",
    path: "/hiring-accept",
    icon: FlagOutlinedIcon,
  },
];

const serviceNavItems = [
  {
    name: "پروژه",
    path: "/project",
    icon: HomeWorkOutlinedIcon,
  },
  {
    name: "سرویس ها",
    path: "/services",
    icon: RouteOutlinedIcon,
  },
  {
    name: "ثبت سرویس",
    path: "/service",
    icon: AddIcon,
  },
];

export default [
  {
    path: "/profile",
    exact: true,
    component: lazy(() => import("../pages/profile")),
    layout: "PanelLayout",
    name: "پروفایل",
  },
  {
    path: "/auth",
    exact: true,
    component: lazy(() => import("../pages/profile")),
    layout: "PanelLayout",
    name: "پروفایل",
  },
  {
    path: "/hiring-list",
    exact: true,
    component: lazy(() => import("../pages/hiringList")),
    layout: "PanelLayout",
    name: "لیست دربستی ها",
    // navBoxItems: hiringNavItems,
  },
  {
    path: "/hiring",
    exact: true,
    component: lazy(() => import("../pages/hiring")),
    layout: "JustNavLayout",
    name: "ثبت دربستی",
    // navBoxItems: hiringNavItems,
  },
  {
    path: "/hiring-request",
    exact: true,
    component: lazy(() => import("../pages/hiringRequest")),
    layout: "JustNavLayout",
    name: "تقاضای دربستی",
    // navBoxItems: hiringNavItems,
  },
  {
    path: "/hiring-request-list",
    exact: true,
    component: lazy(() => import("../pages/hiringRequestList")),
    layout: "PanelLayout",
    name: "لیست دربستی‌ها",
    // navBoxItems: hiringNavItems,
  },
  {
    path: "/hiring-accept",
    exact: true,
    component: lazy(() => import("../pages/hiringAccept")),
    layout: "PanelLayout",
    name: "دربستی های ازاد",
    // navBoxItems: hiringNavItems,
  },
  {
    path: "/driver/list",
    exact: true,
    component: lazy(() => import("../pages/driverList")),
    layout: "PanelLayout",
    name: "ناوگان",
  },
  {
    path: "/driver/add",
    exact: true,
    component: lazy(() => import("../pages/addDriver")),
    layout: "PanelLayout",
    name: "اضافه کردن راننده",
  },
  {
    path: "/driver/edit/:id",
    exact: true,
    component: lazy(() => import("../pages/addDriver")),
    layout: "PanelLayout",
    name: "ویرایش راننده",
  },
  {
    path: "/passenger/list",
    exact: true,
    component: lazy(() => import("../pages/passengerList")),
    layout: "PanelLayout",
    name: "لیست مسافران",
  },
  {
    path: "/passenger/add",
    exact: true,
    component: lazy(() => import("../pages/addPassenger")),
    layout: "PanelLayout",
    name: "افزودن مسافر",
  },
  {
    path: "/passenger/edit/:id",
    exact: true,
    component: lazy(() => import("../pages/addPassenger")),
    layout: "PanelLayout",
    name: "ویرایش مسافر",
  },
  {
    path: "/services",
    exact: true,
    component: lazy(() => import("../pages/services")),
    layout: "PanelLayout",
    name: "سرویس ها",
    // navBoxItems: serviceNavItems,
  },
  {
    path: "/service",
    exact: true,
    component: lazy(() => import("../pages/service")),
    layout: "PanelLayout",
    name: "افزودن سرویس",
    // navBoxItems: serviceNavItems,
  },
  {
    path: "/service/:code?",
    exact: true,
    component: lazy(() => import("../pages/service")),
    layout: "PanelLayout",
    name: "ویرایش سرویس",
  },
  {
    path: "/airplane",
    exact: true,
    component: lazy(() => import("../pages/airplane")),
    layout: "PanelLayout",
    name: "انواع هواپیما (ویژه ایرلاین)",
    // navBoxItems: serviceNavItems,
  },
  {
    path: "/airplane/add",
    exact: true,
    component: lazy(() => import("../pages/airplane/add")),
    layout: "PanelLayout",
    name: "ثبت هواپیمای جدید",
    // navBoxItems: serviceNavItems,
  },
  {
    path: "/airplane/edit/:id",
    exact: true,
    component: lazy(() => import("../pages/airplane/add")),
    layout: "PanelLayout",
    name: "ویرایش هواپیما",
  },
  {
    path: "/project",
    exact: true,
    component: lazy(() => import("../pages/project")),
    layout: "PanelLayout",
    name: "پروژه‌ها",
    // navBoxItems: serviceNavItems,
  },
  {
    path: "/inventories/:code",
    exact: true,
    component: lazy(() => import("../pages/inventories")),
    layout: "PanelLayout",
    name: "برنامه حرکت",
  },
  {
    path: "/operator",
    exact: true,
    component: lazy(() => import("../pages/operator")),
    layout: "PanelLayout",
    name: "اپراتور‌ها",
  },
  {
    path: "/addresses",
    exact: true,
    component: lazy(() => import("../pages/addresses")),
    layout: "PanelLayout",
    name: "آدرس‌ها",
  },
  {
    path: "/passenger/addresses/:staffId",
    exact: true,
    component: lazy(() => import("../pages/addresses")),
    layout: "PanelLayout",
    name: "آدرس‌ها",
  },
  {
    path: "/scheduled-hiring",
    exact: true,
    component: lazy(() => import("../pages/scheduledHiring")),
    layout: "PanelLayout",
    name: "دربستی برنامه‌ریزی شده",
    // navBoxItems: hiringNavItems,
  },
  {
    path: "/scheduled-hiring/:code",
    exact: true,
    component: lazy(() => import("../pages/scheduledHiring")),
    layout: "PanelLayout",
    name: "دربستی برنامه‌ریزی شده",
    // navBoxItems: hiringNavItems,
  },
  {
    path: "/scheduled-hiring-list",
    exact: true,
    component: lazy(() => import("../pages/scheduledHiringList")),
    layout: "PanelLayout",
    name: "لیست دربستی برنامه‌ریزی شده",
    // navBoxItems: hiringNavItems,
  },
  {
    path: "/monitoring",
    exact: true,
    component: lazy(() => import("../pages/monitoring")),
    layout: "PanelLayout",
    name: "مانیتورینگ",
  },
];
